import { Intent } from '@blueprintjs/core';

export default function (error, options) {
  const title = 'Your session has expired';
  const description = 'Your session has expired and you will now be redirected to sign in.';
  const message = 'Your session has expired.';

  return {
    title,
    description,
    message,
    toast: true,
    intent: Intent.DANGER,
    icon: 'error',
  };
}
